const filename = process.env.REACT_APP_ENV
const devs3Config = require('./dev.json');
const prods3Config = require('./prod.json');
var s3Config = devs3Config;
if(window.location.host == 'bookin.newgen.co')
{
    s3Config = prods3Config;
}
export default s3Config;